import CurrencyUtil from '@utils/CurrencyUtil';
import StringUtil from '@utils/StringUtil';
import Vue from 'vue';
import moment from 'moment';
import numeral from 'numeral';

Vue.filter('truncate', function(val, len, suffix = '...') {
    if (val === undefined || val === null || val === '') {
        return '';
    }
    return val.length > len ? val.substring(0, len) + suffix : val;
});

Vue.filter('date', function(val, format = 'MMM D, Y') {
    return val ? moment.unix(val).format(format) : '';
});

Vue.filter('dateTime', function(val, format = 'MMM D, Y h:mm A') {
    return val ? moment.unix(val).format(format) : '';
});

Vue.filter('relativeTime', function(val, withoutSuffix = false) {
    return val ? moment.unix(val).fromNow(withoutSuffix) : '';
});

Vue.filter('relativeTimeInDays', function(val) {
    if (val) {
        let days = moment.unix(val).diff(moment(), 'days');
        return days === 1 ? days + ' day' : days + ' days';
    }
    return '';
});

Vue.filter('numeral', function(val, format = '0,0') {
    return numeral(String(val)).format(format);
});

Vue.filter('currency', function(val) {
    return val ? numeral(val).format('$0,0.00') : '$0.00';
});

Vue.filter('currencyForProject', function(val) {
    return CurrencyUtil.format(val);
});

Vue.filter('paginationTitle', function(val, prefix = '', suffix = '') {
    let str = '';
    str += numeral(val.from).format('0,0');
    str += ' - ';
    str += numeral(val.to).format('0,0');
    str += ' of ';
    str += numeral(val.total).format('0,0');
    return prefix + str + suffix;
});

Vue.filter('pluralize', function(val, num) {
    return num === 1 ? val : val + 's';
});

Vue.filter('capitalize', function(val) {
    return val[0].toUpperCase() + val.slice(1);
});

Vue.filter('urldecode', function(val) {
    return decodeURIComponent(val.replace(/\+/g, ' '));
});

Vue.filter('valueForTrait', function(customer, trait) {
    let val = '';
    let i = trait.field.split('.');
    if (i.length === 1) {
        val = customer?.[i[0]] ? customer[i[0]] : '';
    } else if (i.length === 2) {
        val = customer?.[i[0]]?.[i[1]] ? customer[i[0]][i[1]] : '';
    } else if (i.length === 3) {
        val = customer?.[i[0]]?.[i[1]]?.[i[2]] ? customer[i[0]][i[1]][i[2]] : '';
    }
    return StringUtil.formatValue(trait, val);
});

Vue.filter('valueForProperty', function(property, val) {
    return StringUtil.formatValue(property, val);
});

Vue.filter('segmentsForSelector', function(segments, title = 'Select Segment') {
    let items = segments.map(s => {
        let count = s.customers_count | numeral('0,0');
        return {
            value: s.id,
            title: s.name,
            desc: count + (count === 1 ? ' customer' : ' customers'),
        };
    });
    items.unshift({ value: '', title: title });
    return items;
});

Vue.filter('tagsForSelector', function(tags, title = 'Select Tag') {
    let items = tags.map(t => {
        return { value: t.id, title: t.name };
    });
    items.unshift({ value: '', title: title });
    return items;
});

Vue.filter('formsForSelector', function(forms, title = 'Select Form') {
    let items = forms.map(f => {
        return { value: f.id, title: f.name };
    });
    items.unshift({ value: '', title: title });
    return items;
});

Vue.filter('eventsForSelector', function(events, title = 'Select Event') {
    let items = events.map(e => {
        return { value: e.id, title: e.name };
    });
    items.unshift({ value: '', title: title });
    return items;
});